import Container from "./Container";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

export default function Footer() {
  const location = useLocation();
  const { lang } = useLanguage();
  const copy =
    lang === "zh"
      ? {
          follow: "关注我们",
          links: "链接",
          privacy: "隐私政策",
          terms: "条款",
        }
      : lang === "en" || lang === "ar"
        ? {
            follow: "Follow us",
            links: "Links",
            privacy: "Privacy",
            terms: "Terms",
          }
        : {
            follow: "Volg ons",
            links: "Links",
            privacy: "Privacy",
            terms: "Voorwaarden",
          };

  // The exam owns the full viewport and has its own fixed navigation footer.
  // Rendering the marketing footer after it makes the document scroll below
  // the exam, where it appears behind the CBR controls.
  if (
    location.pathname.startsWith("/app") ||
    location.pathname.startsWith("/quiz")
  ) {
    return null;
  }

  return (
    <footer
      className={`${["/", "/contact", "/inloggen", "/checkout"].includes(location.pathname) ? "home-footer " : ""}mt-20 bg-brand text-white`}
    >
      <Container className="py-12 grid sm:grid-cols-2 gap-8">
        <div>
          <h3 className="font-display text-xl mb-2">{copy.follow}</h3>
          <div className="flex gap-4">
            {/* <a href="https://instagram.com" aria-label="Instagram">Instagram</a>
            <a href="https://youtube.com" aria-label="YouTube">YouTube</a> */}
            <a href="https://tiktok.com/@theorie101.nl" aria-label="Tiktok">
              Tiktok
            </a>
          </div>
        </div>
        <div>
          <h3 className="font-display text-xl mb-2">{copy.links}</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/privacy">{copy.privacy}</Link>
            </li>
            <li>
              <Link to="/voorwaarden">{copy.terms}</Link>
            </li>
          </ul>
        </div>
      </Container>
      <div className="bg-dark text-center text-sm py-4">
        <Container>&copy; {new Date().getFullYear()} THEORIE101</Container>
      </div>
    </footer>
  );
}
